(function () {
  if (!window.matchMedia('(display-mode: standalone)').matches) return;

  var svgInline = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008.39 558.78"><g><polygon fill="#fff" points="311.1 463.4 304.53 463.4 216.66 463.4 210.09 463.4 210.09 456.83 210.09 159.86 164.67 159.86 158.1 159.86 158.1 153.29 158.1 77.35 158.1 70.78 164.67 70.78 356.72 70.78 363.29 70.78 363.29 77.35 363.29 153.29 363.29 159.86 356.72 159.86 311.1 159.86 311.1 456.83 311.1 463.4"/><path fill="#fff" d="M654.49,463.38h-89.95v-6.56l-.06-146.24-17.55,147.02-.69,5.78h-66.06l-.74-5.73-19.24-149.3-.07,148.46v6.56h-89.95V70.78h125.96l.82,5.6c3.34,22.59,6.86,49.82,10.47,80.89l5.54,42.97,14.1-123.63.65-5.83h126.77v392.61Z"/><polygon fill="#fff" points="814.59 463.38 808.04 463.38 720.15 463.38 713.6 463.38 713.6 456.82 713.6 159.83 668.15 159.83 661.6 159.83 661.6 153.28 661.6 77.34 661.6 70.79 668.15 70.79 860.21 70.79 866.77 70.79 866.77 77.34 866.77 153.28 866.77 159.83 860.21 159.83 814.59 159.83 814.59 456.82 814.59 463.38"/></g></svg>';

  function init() {
    // ログイン後リロード中はスプラッシュをスキップ
    if (sessionStorage.getItem('pwa-login-pending')) {
      document.body.style.visibility = 'visible';
      return;
    }
    var parser = new DOMParser();
    var svgDoc = parser.parseFromString(svgInline, 'image/svg+xml');

    var svgBase = svgDoc.documentElement.cloneNode(true);
    var svgFill = svgDoc.documentElement.cloneNode(true);
    svgBase.classList.add('pwa-splash__logo-base');
    svgFill.classList.add('pwa-splash__logo-fill');
    svgFill.style.clipPath = 'inset(0 100% 0 0)';

    var logoWrap = document.createElement('div');
    logoWrap.className = 'pwa-splash__logo';
    logoWrap.appendChild(svgBase);
    logoWrap.appendChild(svgFill);

    var percent = document.createElement('div');
    percent.className = 'pwa-splash__percent';
    percent.textContent = '0%';

    var splash = document.createElement('div');
    splash.id = 'pwa-splash';
    splash.appendChild(logoWrap);
    splash.appendChild(percent);

    document.body.appendChild(splash);
    document.body.style.visibility = 'visible';
    document.body.classList.add('pwa-loading');

    var start = performance.now();
    var duration = 2000;

    function tick(now) {
      var elapsed = now - start;
      var p = Math.min(Math.round((elapsed / duration) * 100), 100);
      var remaining = 100 - p;

      svgFill.style.clipPath = 'inset(0 ' + remaining + '% 0 0)';
      percent.textContent = p + '%';

      if (p < 100) {
        requestAnimationFrame(tick);
      } else {
        setTimeout(function () {
          splash.classList.add('is-hidden');
          document.body.classList.remove('pwa-loading');
          document.body.classList.add('pwa-ready');
          document.body.style.visibility = '';
          setTimeout(function () {
            splash.parentNode && splash.parentNode.removeChild(splash);
          }, 600);
        }, 400);
      }
    }

    requestAnimationFrame(tick);
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }



})();
